import { LazyLoadImage } from 'react-lazy-load-image-component';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

interface IProps {
    title: string,
    image?: {
        url: string,
        urlWebp?: string,
    },
}

const Benefit = ({ title, image }: IProps): JSX.Element => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return (
        <BlockContainer
            rounder={{ $desktop: 32, $mobile: 24 }}
            indent={{ $desktop: [16], $mobile: [12, 16, 12, 12] }}
            bgColor={COLORS.BgMain}
        >
            <ST.Content
                $direction={isMobile ? 'row' : 'column'}
                $wrap={'nowrap'}
                $size={16}
            >
                {!!image?.url && (
                    <ST.Icon
                        rounder={{ $radius: 16 }}
                        indent={{ $united: [8] }}
                        bgColor={COLORS.BgSurface}
                    >
                        <WebpImage urlWebp={image.urlWebp}>
                            <LazyLoadImage src={image.url} alt={title}/>
                        </WebpImage>
                    </ST.Icon>
                )}
                <Paragraph4 $smaller dangerouslySetInnerHTML={{ __html: title }}/>
            </ST.Content>
        </BlockContainer>
    );
};

export default Benefit;
